import { mapActions } from 'vuex';
import _ from 'lodash';
import getUrlParams from '@/utils/getQueryFromUrl';
import BioHelperService from '@/services/bio-helper-service';
import { SEQUENCE_PAGE_SIZE } from '@/constants';
import { getIsFreeView } from 'library-@/utils/patent-view-free-judgment-util';

export default {
    data() {
        return {
            UK_HANDLER_MIXIN_fromChemical: false,
            UK_HANDLER_MIXIN_fromBio: false,
        };
    },
    methods: {
        ...mapActions([
            'bio/setIsUkLoading',
            'bio/setQuerySequence',
            'bio/setQueryProcessing',
            'bio/selectSequences',
            'bio/toggle',
            'bio/setBioPanelLoading',
        ]),
        async UK_HANDLER_MIXIN_getDataByUk(patentId) {
            // 通过路由上是bio_uk还是uk来区分是chemical和bio高亮的逻辑
            // 路由上有bio_uk为bio高亮，uk则为chemical高亮
            if (getUrlParams('bio_uk')) {
                this.UK_HANDLER_MIXIN_fromBio = true;
                await this.syncBioPanelData(patentId);
                this['bio/toggle'](true);
            } else if (getUrlParams('uk')) {
                this.UK_HANDLER_MIXIN_fromChemical = true;
                this['bio/setQueryProcessing'](false);
                this['bio/toggle'](false);
            }
            this['bio/setQueryProcessing'](false);
            this['bio/setIsUkLoading'](false);
        },
        async getSequenceDataByPatentId(patentId) {
            let bioUk = getUrlParams('bio_uk');
            if (!bioUk || getIsFreeView()) return;
            const bioHelperService = new BioHelperService(patentId);
            // 可能是 null
            let folderId = getUrlParams('folder_id') || undefined;
            bioUk = bioUk.split(',');
            const result = await bioHelperService.getSequenceDetailByUk(bioUk, folderId);
            // 获取第一页的序列 100条
            const sequencePage1 = _.get(result, 'selected', [])
                .slice(0, SEQUENCE_PAGE_SIZE);
            const sequenceDetails = await bioHelperService.getSequenceBatch({ sequenceHashIds: sequencePage1.map(x => _.get(x, 'sequence_hash_id')) });
            const sequences = sequencePage1.map(v => {
                const seq = sequenceDetails[v.sequence_number];
                if (seq) {
                    return {
                        sequence_id: seq.sequence_id,
                        sequence: seq.sequence,
                        sequence_len: seq.sequence_len,
                        sequence_type: seq.sequence_type,
                    };
                }
                return _.get(seq, 'sequence_id', '');
            });
            const originQuerySequence = _.get(result, 'query', []);
            const originSelectedSequence = _.get(result, 'selected', []);
            return {
                originQuerySequence,
                sequences: [...sequences, ...originSelectedSequence.slice(SEQUENCE_PAGE_SIZE)],
            };
        },
        async syncBioPanelData(patentId) {
            const res = await this.getSequenceDataByPatentId(patentId);
            if (!res) return;
            const {
                originQuerySequence,
                sequences,
            } = res;
            this['bio/setQuerySequence'](originQuerySequence);
            this['bio/selectSequences'](sequences);
        },
    },
};
